import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { EventCalendarRoutingModule } from './event-calendar-routing.module';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { StoreModule } from '@ngrx/store';
import { eventQueryCommandReducers } from './ngrx.stores/event.query.command/reducers';
import { HttpClientJsonpModule } from '@angular/common/http';

import { CalendarSharedModule } from '../shared/calendar.shared.module';

import { VisitorEventMapComponent } from './components/visitor.event.map/visitor.event.map.component';

@NgModule({
  declarations: [VisitorEventMapComponent],
  imports: [
    CommonModule,
    SharedModule,
    CalendarSharedModule,
    EventCalendarRoutingModule,
    HttpClientJsonpModule,
    ScrollingModule,

    StoreModule.forFeature('eventQueryCommand', eventQueryCommandReducers),
  ],
})
export class EventCalendarModule {}
